import { FC, useMemo } from "react";
import { parse, type StyleOptions } from "src/htmlParser";
import ParsedHtml from "src/Modules/Flights/Pages/JourneyDetails/components/FareRules/components/ParsedHtml";

const GIFTCARD_HTML_STYLES: StyleOptions = {
  columnStyles: "gap-2",
  pieceStyles: "flex flex-col gap-1",
  tableStyles: "w-full border-collapse",
  cellStyles: "border border-border-default p-2 text-start",
  thStyles: "bg-background-minimal font-semibold",
  listStyles: "flex flex-col gap-1 ps-5 items-start",
  ulStyles: "list-disc text-sm!",
  olStyles: "list-decimal text-sm!",
  listLabelStyles: "block font-semibold",
  h1Styles: "font-semibold",
  h2Styles: "font-semibold",
  h3Styles: "font-semibold",
  h4Styles: "font-semibold",
  aStyles: "text-font-active underline",
  pairStyles: "flex gap-2 items-center",
  pairLabelStyles: "text-font-subtle",
  pairValueStyles: "font-semibold",
};

type Props = {
  html?: string | null;
  className?: string;
};

const GiftcardHtml: FC<Props> = ({ html, className }) => {
  const nodes = useMemo(() => (html ? parse(html.replaceAll("\\n", "<br>"), GIFTCARD_HTML_STYLES) : null), [html]);
  if (!nodes) return null;
  return <ParsedHtml nodes={nodes} className={className} />;
};

export default GiftcardHtml;
